<template>
  <div class="home-project-wrapper">
    <img class="protfolio-icon" :src="homeSource('portfolio')" alt="">

    <img class="projects-icon" :src="homeSource('projects-2')" alt="">

    <div class="video-cover-1-wrapper">
      <img class="title" :src="homeSource('project-art-text')" alt="">
<!--      <div class="make-wrapper" @click="playVideo(0, $refs.videoArtRef)">-->
<!--        <img class="cover" :src="homeSource('project-art-pic')" alt="" v-show="!videoArtPlay">-->
<!--        <img class="play" :src="commonSource('play')" alt="" v-show="!videoArtPlay">-->
<!--        <video-play class="cover" ref="videoArtRef" :src="videoSrc(key.PROJECTS_VIDEO_ART)" :show="videoArtPlay" />-->
<!--        &lt;!&ndash;        <video class="cover" ref="videoArtRef" :src="videoSrc(key.PROJECTS_VIDEO_ART)" v-show="videoArtPlay" controls/>&ndash;&gt;-->
<!--      </div>-->
      <video class="make-wrapper" style="cursor: auto" :src="videoSrc(key.PROJECTS_VIDEO_ART)" controls loop autoplay muted="muted"/>
    </div>

    <div class="video-cover-2-wrapper">
      <img class="title" :src="homeSource('project-com-text')" alt="">
<!--      <div class="make-wrapper" @click="playVideo(1, $refs.videoComRef)">-->
<!--        <img class="cover" :src="homeSource('project-com-pic')" alt="" v-show="!videoComPlay">-->
<!--        <img class="play" :src="commonSource('play')" alt="" v-show="!videoComPlay">-->
<!--        <video-play class="cover" ref="videoComRef" :src="videoSrc(key.PROJECTS_VIDEO_COM)" :show="videoComPlay"/>-->
<!--      </div>-->
      <video class="make-wrapper" style="cursor: auto" :src="videoSrc(key.PROJECTS_VIDEO_COM)" controls loop autoplay muted="muted"/>
    </div>

    <div class="video-cover-3-wrapper">
      <img class="title" :src="homeSource('project-multi-text')" alt="">
<!--      <div class="cover-wrapper">-->
<!--        <img class="cover" :src="homeSource('project-multi-pic')" alt="">-->
<!--      </div>-->
      <video class="cover-wrapper" style="cursor: auto" :src="homeSource('project-interactive-video')" controls loop autoplay muted="muted"/>
    </div>

<!--    <div class="all-project-icon" @click="toPage('/products')">-->
<!--      <img :src="homeSource('all-products')" alt="">-->
<!--    </div>-->
  </div>
</template>

<script>
import VideoPlay from "@/components/video-play.vue";
import key from "@/api/key";

export default {
  name: 'home-projects',
  computed: {
    key() {
      return key
    }
  },
  components: { VideoPlay },
  data() {
    return {
      videoArtPlay: false,
      videoComPlay: false
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.stopVideo(0, this.$refs.videoArtRef)
    //   this.stopVideo(1, this.$refs.videoComRef)
    // })
  },
  methods: {
    commonSource(name) {
      return key.getByName(key.COMMON, name).fileUrl
    },
    homeSource(name) {
      return key.getByName(key.HOME_PROJECT, name).fileUrl
    },
    videoSrc(data) {
      return key.get(data)[0].fileUrl
    },
    playVideo(type, ref) {
      if (type === 0) {
        this.videoArtPlay ? ref.stop() : ref.play()
        this.videoArtPlay = !this.videoArtPlay
      } else if (type === 1) {
        this.videoComPlay ? ref.stop() : ref.play()
        this.videoComPlay = !this.videoComPlay
      }
    },
    stopVideo(type, ref) {
      new IntersectionObserver(e => {
        if (e[0].isIntersecting) return
        ref.stop()
        if (type === 0) {
          this.videoArtPlay = false
        } else if (type === 1) {
          this.videoComPlay = false
        }
      }).observe(ref.$refs.videoRef)
    },
  }
}
</script>


<style scoped lang="scss">
.home-project-wrapper {
  position: relative;
  width: 100vw;
  //background-color: #191919;
  background-color: black;
  overflow: hidden;

  .protfolio-icon {
    position: absolute;
    top: 19.635vw;
    left: 0;
    width: 13.958vw;
    height: 78.958vw;
  }

  .projects-icon {
    margin-left: 71.6vw;
    margin-top: 6.667vw;
    width: 24.74vw;
    height: 3.49vw;
  }

  .video-cover-1-wrapper {
    position: relative;
    margin-top: 4.323vw;
    height: 42.96875vw;

    .title {
      position: absolute;
      top: 13.073vw;
      left: 4.167vw;
      width: 64.375vw;
      height: 29.896vw;
    }

    .make-wrapper {
      position: absolute;
      top: 0;
      left: 29.583vw;
      width: 66.667vw;
      height: 37.5vw;
      cursor: pointer;
      overflow: hidden;

      .cover {
        width: 100%;
        height: 100%;
        transition: all .3s;

        &:hover {
          transform: scale(1.03);
        }
      }

      .play {
        position: absolute;
        top: 13.4375vw;
        left: 25.365vw;
        width: 7.083vw;
        height: 7.083vw;
      }
    }
  }

  .video-cover-2-wrapper {
    position: relative;
    margin-top: 6.198vw;
    margin-left: 17.03125vw;
    height: 50vw;

    .title {
      position: absolute;
      top: 0;
      width: 12.552vw;
      height: 50vw;
    }

    .make-wrapper {
      position: absolute;
      top: 0;
      left: 12.552vw;
      width: 66.667vw;
      height: 50vw;
      cursor: pointer;
      overflow: hidden;

      .cover {
        width: 100%;
        height: 100%;
        transition: all .3s;

        &:hover {
          transform: scale(1.03);
        }
      }

      .play {
        position: absolute;
        top: 21.458vw;
        left: 25.417vw;
        width: 7.083vw;
        height: 7.083vw;
      }
    }
  }

  .video-cover-3-wrapper {
    position: relative;
    height: 41.146vw;
    margin-top: 9.167vw;
    margin-left: 4.167vw;

    .title {
      position: absolute;
      top: 4.427vw;
      right: 4.167vw;
      width: 38.385vw;
      height: 36.667vw;
    }

    .cover-wrapper {
      position: absolute;
      top: 0;
      width: 66.667vw;
      height: 37.5vw;
      overflow: hidden;

      .cover {
        width: 100%;
        height: 100%;
        transition: all .3s;

        &:hover {
          transform: scale(1.03);
        }
      }
    }
  }

  .all-project-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5.99vw 0 6.979vw 0;

    img {
      width: 21.979vw;
      height: 3.28125vw;
    }

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
